import type { Project } from '@octopus-do/octopus-project-core'
import { managerActions } from '@store/reducers/manager/actions'
import { StorageActions } from '@store/reducers/manager/storage'
import axios, { type AxiosResponse } from 'axios'
import { call, put } from 'redux-saga/effects'

import { GlobalActions } from '@/store'

type PreviewResponse = AxiosResponse<{
  project: Project
}>

const fetchPreview = (id: string): Promise<PreviewResponse> =>
  axios.get(`/preview/${id}`, {
    baseURL: import.meta.env.VITE_SYNC_HTTP_URL,
    headers: {
      'X-Export-Token': localStorage.getItem('export_token'),
    },
  })

export function* initPreviewSaga({
  payload: { id },
}: ReturnType<typeof managerActions.previewInit>) {
  const projectResponse: PreviewResponse = yield call(fetchPreview, id)

  const { data } = projectResponse

  yield put(managerActions.loadProject(data))
  // Вложения раньше грузил стартовый init из useIntervals; после его удаления
  // на этом роуте storage больше никто не запрашивает
  yield put(StorageActions.init({ id }))
  yield put(GlobalActions.notifyReady({ attempt: 1 }))
}
